import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { submitEnquiry } from "@/lib/api";

const inputCls =
  "w-full bg-cream border border-chocolate/15 px-4 py-3 text-sm text-chocolate placeholder:text-chocolate/35 focus:outline-none focus:border-gold transition-colors rounded-none";
const labelCls = "block font-mono text-[10px] uppercase tracking-[0.25em] text-chocolate/60 mb-2";

export default function ContactForm() {
  const [sending, setSending] = useState(false);
  const [data, setData] = useState({ name: "", email: "", subject: "", message: "" });
  const set = (key) => (e) => setData((d) => ({ ...d, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!data.name.trim() || !data.email.trim() || !data.message.trim()) {
      toast.error("Please complete your name, email and message.");
      return;
    }
    setSending(true);
    try {
      await submitEnquiry("contact", data);
      toast.success("Message sent — we'll be in touch within one working day.");
      setData({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again or email Salem-sabrina-thegiftedit@outlook.com.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label className={labelCls} htmlFor="ct-name">Your name *</label>
          <input id="ct-name" data-testid="contact-name" className={inputCls} value={data.name} onChange={set("name")} placeholder="Full name" />
        </div>
        <div>
          <label className={labelCls} htmlFor="ct-email">Email *</label>
          <input id="ct-email" data-testid="contact-email" type="email" className={inputCls} value={data.email} onChange={set("email")} placeholder="you@email.com" />
        </div>
      </div>
      <div>
        <label className={labelCls} htmlFor="ct-subject">Subject</label>
        <select id="ct-subject" data-testid="contact-subject" className={inputCls} value={data.subject} onChange={set("subject")}>
          <option value="">Select…</option>
          {["A bespoke Gift Edit", "The Collection", "Private Concierge", "An existing order", "Press & partnerships", "Something else"].map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={labelCls} htmlFor="ct-message">Message *</label>
        <textarea id="ct-message" data-testid="contact-message" rows={5} className={inputCls} value={data.message} onChange={set("message")} placeholder="How can we help?" />
      </div>
      <button
        type="submit"
        data-testid="contact-form-submit"
        disabled={sending}
        className="inline-flex items-center gap-2 bg-chocolate text-cream px-8 py-4 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-espresso transition-colors disabled:opacity-60"
      >
        {sending ? "Sending…" : "Send Message"} <ArrowRight size={14} />
      </button>
    </form>
  );
}
